import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {transactionsPaymentList_template} from "../components/templates/transactionsPaymentList_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class transactions_payment extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: transactionsPaymentList_template;
    protected pagination: pagination_template;

    protected getModuleName(){
        return "transactions_payment";
    }

    buildContent() : Array<Element>{

        this.elementsList = new transactionsPaymentList_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Generate Slips");
        return [this.elementsList.build()];
    }

    public fillPage() : void{
        this.elementsList.buildDatePickerCalendar();

        this.filterList();
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected filterSimpleOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();

    }

    protected filterSimpleCancel(){

    }

    protected filterSingleDateOnChange(){
        this.filterList();
    }

    protected transactionPaymentListReorder(){
        this.filterList();
    }

    protected showNoneTransactionToPay(){

        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "There's no transaction to pay!");
        this.getVnAppZone().showNotificationToModule();

    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker
            },
            account: this.viewModel.list.filterPaymentAccount.selectedOption,
            list: {
                orderBy: this.viewModel.list.orderBy,
                orderByDirection: this.viewModel.list.orderByDirection
            },
            pagination: this.viewModel.list.pagination

        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

                if( localCheck == _myThis.XHRHdl.requestId ){
                   _myThis.XHRHdl.onReadyStateFunction = _myThis.onFilterRequestReturn;
                   _myThis.XHRHdl.execute();
                }
            }, 400);
    }

    protected onFilterRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                if(  req.request.status == 200  ){

                    obj.updateList(data);
                    obj.getPaymentSummary();
                }else if( req.request.status == "423" ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions');
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list

            this.elementsList.setBrand(responseParsed.brand);
            this.elementsList.setTransactions(responseParsed.transactions);
            this.elementsList.setLastPayDate(responseParsed.lastPayDate);
            this.viewModel.list.pagination.itemCount(responseParsed.total);
            this.viewModel.list.pagination.itemCount(responseParsed.total);
            let paymentViews = [
                {
                    paymentViewId: 0,
                    paymentViewText: 'Transactions'
                },
                {
                    paymentViewId: 1,
                    paymentViewText: 'Summary'
                }
            ];
            this.viewModel.list.filterPaymentView.setPaymentViews(paymentViews);

            let accounts = [];
            Array.prototype.push.apply(accounts, responseParsed.accounts);
            this.viewModel.list.filterPaymentAccount.setOptions(accounts);
    }

    protected onUpdateError(requestStatus: any, responseParsed) : void{
        let msg = "error: while obtaining the data - (" + responseParsed.message +")";
        this.elementsList.validationsList.setSingleMessage({field: "error", "label": requestStatus, message: msg});
        window.scrollTo(0, 0);
    }

    protected pay(){

        this.elementsList.builtTemplate.classList.add("loading");

        let _this = this;
        let subViewModel = {
            account: this.viewModel.list.filterPaymentAccount.selectedOption,
            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker
            }

        };

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/pay/';
        let formReq_params: Array<Array<string>> = [ ['data', ko.toJSON(subViewModel)]];
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = function(req, obj) {
            return function() {
                if (req.request.readyState == 4) {

                    let responseParsed = JSON.parse(req.request.response);

                    if (req.request.status == 200) {

                        //obj.releaseLock();
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Transactions have been paid successfully !");
                        obj.getVnAppZone().showNotificationToModule();
                        obj.elementsList.validationsList.clearMessages();

                        page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions/payments');

                    } else if (responseParsed.type == 'error_validation') {

                        obj.elementsList.validationsList.setMessages(responseParsed.validations);
                        window.scrollTo(0, 0);

                    } else if (responseParsed.type == 'error') {

                        obj.elementsList.validationsList.setSingleMessage({field: "error", label: req.request.status, message: responseParsed.message});
                        window.scrollTo(0, 0);
                    }

                    // LOADING : ends
                    obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                }
            }
        };

        XHRHdl.execute();

    }

    protected reverse_payment(){

        this.elementsList.builtTemplate.classList.add("loading");

        let _this = this;
        let subViewModel = {

            filterDate: {
                paymentDate: this.viewModel.list.filterDate.singleDatePicker
            }

        };

        let formReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payment/reverse';
        let formReq_params: Array<Array<string>> = [ ['data', ko.toJSON(subViewModel)]];
        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);

        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = function(req, obj) {
            return function() {
                if (req.request.readyState == 4) {

                    let responseParsed = JSON.parse(req.request.response);

                    if (req.request.status == 200) {

                        //obj.releaseLock();
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Payment reversed successfully !");
                        obj.getVnAppZone().showNotificationToModule();
                        obj.elementsList.validationsList.clearMessages();

                        page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions/payments');

                    } else if (responseParsed.type == 'error_validation') {

                        obj.elementsList.validationsList.setMessages(responseParsed.validations);
                        window.scrollTo(0, 0);

                    } else if (responseParsed.type == 'error') {

                        obj.elementsList.validationsList.setSingleMessage({field: "error", label: req.request.status, message: responseParsed.message});
                        window.scrollTo(0, 0);
                    }

                    // LOADING : ends
                    obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                }
            }
        };

        XHRHdl.execute();

    }

    protected getUserPaymentDetails(id){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("summary-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            datePayment: this.viewModel.list.filterDate.singleDatePicker,
            idUser: id
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/user/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onTransactionRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onTransactionRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;
                if(  req.request.status == 200  ){
                    obj.updateUserTransactions(data);
                }else if( req.request.status == "423" ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/payment/transactions');
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("summary-results"));
            }
        }
    }

    //
    // update the list of transactions for the specified user
    protected updateUserTransactions(responseParsed: any){
        // set users list
        let users = this.viewModel.list.users();
        let idUser = responseParsed.user;
        let index = users.map(function(x) {return x.user_id; }).indexOf(idUser);

        for (let item of responseParsed.transactions) {

            var project_name, total, dateScheduled, idYoutube;
            var entry_type = item.entry_type;

            if (item.action_type_id == 3 || item.project_name == null){
                project_name = "N/A";
                idYoutube = "N/A";
            }
            else{
                project_name = item.project_name.substring(0,40) + '...';
                idYoutube = item.idYoutube;
            }

            if (item.action_type_id == 2){
                entry_type = "Reversal of " + entry_type;
            }

            total = (item.type_id == 1) ? '-$' + Number(item.total).toLocaleString(undefined, {minimumFractionDigits: 2}): '$' + Number(item.total).toLocaleString(undefined, {minimumFractionDigits: 2});
            dateScheduled = item.dateScheduled.substring(0,10);

            users[index].transactions.push( {
                entry_type: entry_type
                ,project_name: project_name
                ,idYoutube: idYoutube
                ,dateCreation: dateScheduled
                ,amount: total
            });
        }
        this.elementsList.setUsers([]);
        this.elementsList.setUsers(users);
    }

    public onChangePaymentView(idPaymentView) {
        this.viewModel.list.isSummaryVisible(!this.viewModel.list.isSummaryVisible());
        if (this.viewModel.list.users().length == 0 && idPaymentView == 1){
            this.getPaymentSummary();
        }
    }

    protected getPaymentSummary(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("summary-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
        let subViewModel = {
                datePayment: this.viewModel.list.filterDate.singleDatePicker
        };

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/transactions/payments/summary/preview/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push( ["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onSummaryRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onSummaryRequestReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);
                let data = responseParsed.data;

                if(  req.request.status == 200  ){

                    obj.updateSummary(data);
                }else if( req.request.status == "423" ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("summary-results"));
            }
        }
    }

    protected updateSummary(responseParsed: any){

        // set users list
        let users = [];
        if(responseParsed.users) {
            for (let item of responseParsed.users) {
                var total = (item.total < 0) ? '$0.00 ($' + item.total.toLocaleString(undefined, {minimumFractionDigits: 2}) + ')' : '$' + item.total.toLocaleString(undefined, {minimumFractionDigits: 2});

                users.push({
                    total: total
                    , user_id: item.id
                    , user_fullName: item.fullName
                    , paymentEmail: item.paymentEmail
                    , currency: item.currency
                    , transactions: []
                    , showDetails: false
                })
            }
        }
        this.elementsList.setUsers(users);
    }
    //

    public filterDropdownOnChange(){
        this.filterList();
    }

}



// WEBPACK FOOTER //
// ./js/modules/transactions_payment.ts